namespace Areas {
    "use strict";

    export class FilterBuilder {
        filterValue: any;
        readonly filterButtonName = "filterButton_" + new DevExpress.data.Guid().toString();
        readonly clearFilterButtonName = "clearFilterButton_"+ new DevExpress.data.Guid().toString();

        readonly grid: DevExpress.ui.dxDataGrid;
        private readonly toolbarOptions: any;

        constructor(grid: DevExpress.ui.dxDataGrid, toolbarOptions: any) {
            this.grid = grid;
            this.toolbarOptions = toolbarOptions;
        }

        addButtons() {
            addButtonToToolbar(this.toolbarOptions, {
                elementAttr: { id: this.filterButtonName },
                text: "Advanced Filter",
                hint: "Create an advanced filter",
                type: "normal",
                icon: "filter",
                onClick: this.showFilterDialog()
            }, "after");     
            
            addButtonToToolbar(this.toolbarOptions, {
                elementAttr: { id: this.clearFilterButtonName },
                text: "Clear Filter",
                hint: "Clear the filter",
                type: "normal",
                disabled: true,
                onClick: this.clearFilter()
            }, "after"); 
        }

        private showFilterDialog() {
            return (e: any) => {
                let fields = this.getFields();

                const parameters = {
                    filterValue: this.filterValue,
                    fields: fields
                };

                const dialog = new Areas.Dialogs.FilterBuilderDialog(this.filterBuilderClosed(this), parameters);
            }
        }

        private getFields(): any {
            let fields = [];

            for (let i = 0; i < this.grid.columnCount(); i++) {
                const columnOption = this.grid.columnOption(i);

                if (columnOption.dataField) {
                    fields.push(this.buildField(columnOption));
                }
            }

            return fields;
        }

        private buildField(columnOption: any): any {
            if (columnOption.displayField) {
                return {
                    dataField: columnOption.displayField,
                    dataType: "string",
                    caption: columnOption.caption,
                    format: columnOption.format
                };
            }

            return {
                dataField: columnOption.dataField,
                dataType: columnOption.dataType,
                caption: columnOption.caption,
                format: columnOption.format
            };
        }

        private clearFilter() {
            return (e: any) => {
                this.grid.clearFilter();
                this.filterValue = null;
                e.component.option("disabled", true);
                $(`#${this.filterButtonName}`).dxButton("instance").option("type", "default");
            };
        }

        private filterBuilderClosed (filterBuilder: FilterBuilder) {
            return (result: Areas.DialogResult, data: any) => {
                if (result === DialogResult.Cancel) return;

                filterBuilder.filterValue = data.filter;

                filterBuilder.grid.filter(data.filter);

                $(`#${filterBuilder.filterButtonName}`).dxButton("instance")
                    .option("type", data.filter ? "success" : "default");

                $(`#${filterBuilder.clearFilterButtonName}`).dxButton("instance")
                    .option("disabled", !data.filter);
            }
        }
    }    
}